import type { ComponentProps } from 'react'
import Submit from '../../shared/Submit'

type SubmitProps = ComponentProps<typeof Submit>

/**
 * Step 6: Submit
 * Wrapper for shared Submit component
 */
export default function Step6_Submit(props: SubmitProps) {
  return <Submit {...props} />
}
